import Icon from '@components/icons/Icon';
import { useNavigation } from '@react-navigation/native';
import { IconButton, theme } from 'aimo-ui';
import useIsLoggedIn from 'hooks/useIsLoggedIn';
import useSupportStatus from 'hooks/useSupportStatus';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { AccountScreenNavigationProp } from 'types/navigation';
import { useUiStore } from 'stores/uiStore';

type HelpButtonProps = {
  testID?: string;
};

const HelpIcon = () => <Icon name="Help" size="l" color={theme.colors.white} />;
const ChatIcon = () => (
  <Icon name="Chat-Outlined" size="m" color={theme.colors.white} />
);

const HelpButton = ({ testID }: HelpButtonProps) => {
  const { navigate: navigateAccount } =
    useNavigation<AccountScreenNavigationProp>();
  const { t } = useTranslation();
  const { isLoggedIn } = useIsLoggedIn();
  const { isAvailable, open } = useSupportStatus();

  const showChat = isAvailable && isLoggedIn;

  const onPress = async () => {
    if (showChat) {
      await open();
    } else if (isLoggedIn) {
      navigateAccount('contactUs');
    } else {
      useUiStore.getState().setSheetModal('selectCountryForSupport');
    }
  };

  return (
    <View>
      <IconButton
        padding={showChat ? 13 : 10}
        fullWidth={false}
        onPress={onPress}
        rounded
        testID={testID}
        iconComponent={showChat ? ChatIcon : HelpIcon}
        accessibilityLabel={t('ariaLabels.help')}
      />
      {showChat && <View style={styles.dot} />}
    </View>
  );
};

const styles = StyleSheet.create({
  dot: {
    position: 'absolute',
    top: 2,
    right: 2,
    width: 12,
    height: 12,
    borderRadius: 10,
    backgroundColor: '#00EB62',
    borderWidth: 2,
    borderColor: theme.colors.white,
  },
});

export default HelpButton;
